/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UserProfileActiveTenantRequest {
    getFixupPrototypeFunction() { return UserProfileActiveTenantRequest.fixupPrototype; }

    static newInstance(model: Partial<UserProfileActiveTenantRequest>): UserProfileActiveTenantRequest {
        let obj = Object.assign(new UserProfileActiveTenantRequest(), model);
        UserProfileActiveTenantRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UserProfileActiveTenantRequest>): UserProfileActiveTenantRequest {
        if (!model) return null;
        return UserProfileActiveTenantRequest.newInstance(<UserProfileActiveTenantRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UserProfileActiveTenantRequest) {
        if (!obj) return;

        models.UserProfileActiveTenantRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UserProfileActiveTenantRequest): boolean {
        Object.setPrototypeOf(obj, UserProfileActiveTenantRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Tenant ID to set as active
     */
    tenant_id: string;

}
